import React from "react";
import "./ProjectCard.css";

const ProjectCard = ({ card }) => {
  const { name, github, live, image, description } = card;
  return (
    <div>
      <div className="overflow-hidden rounded-2xl bg-slate-800 text-white shadow-md shadow-black">
        {/*  <!-- Image --> */}
        <figure className="lg:p-6 p-2 pb-0 ">
          <span className="relative inline-flex xl:w-[360px] items-center justify-center rounded-full text-white">
            <img
              src={image}
              alt="user name"
              className="max-w-full xl:block hidden rounded-lg"
            />
          </span>
        </figure>
        {/*  <!-- Body--> */}
        <div className="p-2">
          <header className="mb-4">
            <h3 className="text-xl font-medium">{name}</h3>
            <p className=" text-slate-400"> {description} </p>
          </header>
        </div>
        {/*  <!-- Action base sized with lead icon buttons  --> */}
        <div className="flex justify-center gap-6 p-6 pt-0">
          <a href={github} target="_blank" rel="noreferrer">
            {/* <button className="inline-flex uppercase h-10 items-center justify-center gap-2 justify-self-center whitespace-nowrap rounded bg-white px-5 text-sm font-medium tracking-wide text-secondary transition duration-300 hover:bg-secondary hover:text-white focus-visible:outline-none disabled:cursor-not-allowed disabled:border-emerald-300 disabled:bg-emerald-100 disabled:text-emerald-400 disabled:shadow-none">
              <span>Github Link</span>
            </button> */}
            <button className="d-5 underline hover:no-underline underline-offset-8 decoration-primary">
              <span> Github Link</span>
            </button>
          </a>
          <a href={live} target="_blank" rel="noreferrer">
            {/* <button className="inline-flex uppercase h-10 flex-1 items-center justify-center gap-2 whitespace-nowrap rounded bg-secondary px-5 text-sm font-medium tracking-wide text-white transition duration-300 hover:bg-white hover:text-secondary focus-visible:outline-none disabled:cursor-not-allowed disabled:border-emerald-300 disabled:bg-emerald-300 disabled:shadow-none">
              <span className="order-2">Live Website</span>
            </button> */}
            <button className="d-5 underline hover:no-underline underline-offset-8 decoration-primary">
              Live Website
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
